<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"><i></i> </span></p>
<p class="p3"><span class="sz"><i></i> </span></p>
<p class="p4"><span class="sz"><i>To</i> GUY BLOOMER</span></p>
<p class="p4"><span class="sz"><i>In memory of Gibraltar days</i></span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?4a248fb1